import { render, staticRenderFns } from "./paragraphBlock.vue?vue&type=template&id=538131cc&scoped=true&"
import script from "./paragraphBlock.vue?vue&type=script&lang=js&"
export * from "./paragraphBlock.vue?vue&type=script&lang=js&"
import style0 from "./paragraphBlock.vue?vue&type=style&index=0&id=538131cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538131cc",
  null
  
)

export default component.exports